import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { PrimeNGModules } from '../../shared/alpha-shared.module';

@Component({
    selector: 'app-bread-crumb',
    standalone: true,
    imports: [...PrimeNGModules, TranslatePipe],
    templateUrl: './bread-crumb.component.html',
    styleUrl: './bread-crumb.component.scss',
})
export class BreadCrumbComponent implements OnChanges {
    @Input() items: MenuItem[] | undefined;

    @Input() home: MenuItem | undefined;

    ngOnChanges(changes: SimpleChanges): void {
        this.items = this.items;
    }
}
